'use client';

import { useShallow } from 'zustand/shallow';
import {
  useAppTargetId,
  useProjectStore,
  useTargetType,
} from '../../store/projectStore';
import { TARGET_TYPE } from '../../utils/target-scope.utils';
import { InternalNetworkSettingsTab } from './network/InternalNetworkSettingsTab';
import { ExternalNetworkSettingsTab } from './network/ExternalNetworkSettingsTab';
import { WebApplicationSettingsTab } from './target-settings/WebApplicationSettingsTab';

export function TargetSettingsTab({ tabId }: { tabId: string }) {
  const { companyId, selectedTarget } = useProjectStore(
    useShallow((state) => ({
      companyId: state.companyId,
      selectedTarget: state.selectedTarget,
    })),
  );
  const targetType = useTargetType();
  const appTargetId = useAppTargetId();

  if (targetType === TARGET_TYPE.INTERNAL_NETWORK) {
    return (
      <InternalNetworkSettingsTab networkId={selectedTarget?.id ?? null} />
    );
  }

  if (targetType === TARGET_TYPE.EXTERNAL_NETWORK) {
    return (
      <ExternalNetworkSettingsTab surfaceId={selectedTarget?.id ?? null} />
    );
  }

  return (
    <WebApplicationSettingsTab
      tabId={tabId}
      companyId={companyId}
      selectedTarget={selectedTarget}
      appTargetId={appTargetId}
    />
  );
}
